import { useEffect, useRef, useState } from 'react';

const useCookieSettings = () => {
  const cookieSettingsOpenButton = useRef<HTMLElement | null>(null);
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  const handleCookieSettingsClick = () => {
    cookieSettingsOpenButton.current?.click();
  };

  const handleInitialCookieButtonDisplayed = (
    initialCookieButtonElement: HTMLDivElement
  ) => {
    // eslint-disable-next-line no-param-reassign
    initialCookieButtonElement.style.visibility = 'hidden';
    const openButton = initialCookieButtonElement.querySelector(
      '.ot-floating-button__open'
    ) as HTMLElement | null;
    cookieSettingsOpenButton.current = openButton;
    setShowCookieSettings(true);
  };

  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      const initialCookieButtonElement = (
        mutationsList
          .reduce<Node[]>(
            (acc, item) => [...acc, ...Array.from(item.addedNodes)],
            []
          )
          .find(
            (element) =>
              (element as HTMLDivElement).id === 'onetrust-consent-sdk'
          ) as HTMLDivElement
      )?.querySelector('#ot-sdk-btn-floating') as HTMLDivElement;

      if (initialCookieButtonElement) {
        handleInitialCookieButtonDisplayed(initialCookieButtonElement);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      subtree: false,
      childList: true,
    });

    const initialCookieButtonElement = document.getElementById(
      'ot-sdk-btn-floating'
    ) as HTMLDivElement;

    if (initialCookieButtonElement)
      handleInitialCookieButtonDisplayed(initialCookieButtonElement);
  }, []);

  return { showCookieSettings, handleCookieSettingsClick };
};

export default useCookieSettings;
